import { Box, ClickAwayListener, Fab, Modal } from '@mui/material';
import CloseIcon from 'mdi-react/CloseIcon';
import { bool, func, node, object, string } from 'prop-types';
import React from 'react';

function getModalStyle() {
  return {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  };
}

const MyModal = ({ isOpen, onClose, children, className = null, sx: modalSx = null }) => (
  <Modal
    aria-labelledby="simple-modal-title"
    aria-describedby="simple-modal-description"
    open={isOpen}
    onClose={onClose}
    sx={modalSx}
  >
    <div style={getModalStyle()}>
      <ClickAwayListener onClickAway={onClose}>
        <Box
          className={className}
          sx={{
            borderRadius: '3px',
            backgroundColor: 'background.paper',
            maxWidth: '90vw',
            boxShadow: 5,
            '&:focus': {
              outline: 'none',
            },
            position: 'relative',
            p: { xs: 1, sm: 2 },
          }}
        >
          {children}
          <Fab
            onClick={onClose}
            aria-label="Close"
            sx={{
              display: { xs: 'none', sm: 'flex' },
              width: 40,
              height: 40,
              alignItems: 'center',
              borderRadius: '100%',
              top: '-15px',
              right: '-15px',
              position: 'absolute',
            }}
          >
            <CloseIcon />
          </Fab>
        </Box>
      </ClickAwayListener>
    </div>
  </Modal>
);

MyModal.propTypes = {
  children: node.isRequired,
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  className: string,
  sx: object,
};

export default MyModal;
